<template>
  <aside class="app-sidebar" :class="{ open: isShowNavigationBar }">
    <div class="app-sidebar__inner mx-xl-24">
      <div class="app-sidebar__nav pt-20 pt-xl-0">
        <div class="item p-11 mt-10 mt-xl-20 text-center" @click="goToHomePage">
          <div class="icon">
            <svg
              width="16"
              height="18"
              viewbox="0 0 16 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.2 6.1626L8.45 0.918558C8.15 0.693814 7.775 0.693814 7.55 0.918558L0.8 6.1626C0.575 6.31243 0.5 6.53717 0.5 6.76192V15.0026C0.5 16.2761 1.475 17.25 2.75 17.25H13.25C14.525 17.25 15.5 16.2761 15.5 15.0026V6.76192C15.5 6.53717 15.425 6.31243 15.2 6.1626ZM9.5 9.75851V15.7517H6.5V9.75851H9.5ZM13.25 15.7517C13.7 15.7517 14 15.452 14 15.0026V7.13649L8 2.49177L2 7.13649V15.0026C2 15.452 2.3 15.7517 2.75 15.7517H5V9.00936C5 8.55988 5.3 8.26022 5.75 8.26022H10.25C10.7 8.26022 11 8.55988 11 9.00936V15.7517H13.25Z"
                fill="#42515F"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <div
      class="bg-overlay bg-app-sidebar"
      :class="{ open: isShowNavigationBar }"
      @click="hideNavigationBar"
    ></div>
  </aside>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-facing-decorator'
import { State, Action, namespace } from 'vuex-facing-decorator'
import type { User } from '@/model/user/schema'

const AuthStore = namespace('auth')

@Component({})
export default class SiteSideBar extends Vue {
  @State isShowNavigationBar
  @Action toggleNavigationBar
  @Action setCurrentSkill
  @AuthStore.Getter currentUser: User

  hideNavigationBar() {
    this.toggleNavigationBar(false)
  }

  goToHomePage() {
    this.setCurrentSkill({})

    // ユーザーのhome_url設定があればそれに遷移、なければルートに遷移
    const homeUrl = this.getUserHomeUrl()

    if (/^https?:\/\//.test(homeUrl)) {
      window.location.assign(homeUrl)
      return
    }

    // 現在のパスと同じ場合は何もしない
    if (
      this.$route.path === homeUrl ||
      (homeUrl === '/' && this.$route.name === 'Home')
    ) {
      return
    }

    this.$router.push(homeUrl)
  }

  getUserHomeUrl(): string {
    // ユーザーのhome_url設定があればそれを使用、なければルートページ
    if (this.currentUser.home_url) {
      return this.currentUser.home_url
    }
    return '/'
  }
}
</script>

<style lang="sass" scoped></style>
